module.exports = __webpack_public_path__ + "img/wb_bg_support-startups.c46bacc4.jpg";